<template>
  <div>
    <label class="font-weight-bold">Promotion type:</label><br>
    <li class="ml-3 mb-1">{{form.application_type === 'automatic' ? 'Automatic application' : 'Via voucher/discount code'}}</li>
    <li class="ml-3 mb-1">{{promoLogicName(form.sales_channel_promo_logic)}}</li>
    <br>
    <div v-if="current > 0">
      <label class="font-weight-bold">Available on:</label><br>
      <li class="ml-3 mb-1" v-for="salesChannelId in Object.keys(Object.fromEntries(Object.entries(this.form.sales_channel_stores).filter(v => v[1])))" v-bind:key="salesChannelId">
        {{salesChannelAccountName(salesChannelId)}}
      </li>
  </div>
    <br>
    <div v-if="current > 1 && form.data">
      <label class="font-weight-bold">Promotion details:</label><br>
      <!-- form.data.value -->
      <li class="ml-3 mb-1" v-if="form.sales_channel_promo_logic.includes('percentage_discount')">
        {{form.data.value}}% off {{form.data.target_selection}} products
      </li>
      <li class="ml-3 mb-1" v-if="form.sales_channel_promo_logic.includes('fixed_amount_discount')">
        ₱{{form.data.value}} off {{form.data.target_selection}} products
      </li>
      <li class="ml-3 mb-1" v-if="form.sales_channel_promo_logic.includes('percentage_discount') || form.sales_channel_promo_logic.includes('fixed_amount_discount')">
        Applied {{form.data.allocation_method === 'each' ? 'to each eligible item per order' : 'across the order'}}
      </li>
      <li class="ml-3 mb-1" v-if="form.sales_channel_promo_logic.includes('free_shipping')">
        Free shipping on all products
      </li>
      <li class="ml-3 mb-1" v-if="form.sales_channel_promo_logic.includes('buy_get')">
        <span v-if="form.data._prerequisite_content === 'amount'">Spend ₱{{form.data.prerequisite_to_entitlement_purchase.prerequisite_amount}}, </span>
        <span v-else>Buy {{form.data.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity}} items, </span>
        Get {{form.data.prerequisite_to_entitlement_quantity_ratio.entitled_quantity}}
        at {{form.data.value}}% off
      </li>
      <li class="ml-3 mb-1" v-if="form.sales_channel_promo_logic.includes('free_shipping')">
        <span v-if="form.data._prerequisite_shipping_price_range && !form.data.period_type">
          Applies to shipping rates under ₱{{form.data.prerequisite_shipping_price_range.less_than_or_equal_to}}
        </span>
        <span v-else-if="form.data._prerequisite_shipping_price_range && form.data.period_type">
          Applies to all shipping rates with the maximum subsidy of ₱{{form.data.prerequisite_shipping_price_range.less_than_or_equal_to}}
        </span>
        <span v-else>
          Applies to all shipping rates
        </span>
      </li>
      <li class="ml-3 mb-1" v-if="form.sales_channel_promo_logic.includes('discounted_amount')">
        Applies to {{form.data._entitled_products.length}} item{{form.data._entitled_products.length > 1 ? 's' : ''}}
      </li>
      <li class="ml-3 mb-1">
        Available for {{form.data.customer_selection}} customers
      </li>
      <li class="ml-3 mb-1" v-if="form.data._prerequisite_type && form.data._prerequisite_type !== 'none' && !form.sales_channel_promo_logic.includes('buy_get')">
        Minimum purchase of
        <span v-if="form.data._prerequisite_type === 'subtotal'">₱{{form.data.prerequisite_subtotal_range.greater_than_or_equal_to}}</span>
        <span v-if="form.data._prerequisite_type === 'quantity'">{{form.data.prerequisite_quantity_range.greater_than_or_equal_to}} items</span>
      </li>
      <li class="ml-3 mb-1" v-if="form.data._allocation_limit && form.data.allocation_limit > 0">
        Can be used {{form.data.allocation_limit}} time/s per order
      </li>
      <li class="ml-3 mb-1" v-if="form.data._usage_limit && form.data.usage_limit > 0">
        Limit of {{form.data.usage_limit}} uses
      </li>
      <li class="ml-3 mb-1" v-if="form.data.once_per_customer">
        One use per customer
      </li>
      <li class="ml-3 mb-1" v-if="form.promo_status === 'active' && current > 2 && form.data.starts_at">
        <span v-if="form.data.period_type === 'LONG_TERM'">
          Active from {{form.data.starts_at | formatPeriodDate}}
          <span v-if="form.data._ends_at">to {{form.data.ends_at | formatPeriodDate}}</span>
        </span>
        <span v-else>
          Available anytime
        </span>
      </li>
      <li class="ml-3 mb-1" v-if="form.promo_status === 'inactive' && current > 2">
        Inactive promotion
      </li>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      form: Object,
      salesChannelAccounts: Array,
      salesChannels: Array,
      current: Number
    },
    name: 'promotion-data-summary',
    methods: {
      promoLogicName: function(code){
        let name = ''
        switch (code) {
          case 'automatic_percentage_discount':
          case 'voucher_percentage_discount':
            name = 'Percentage discount'
            break
          case 'automatic_fixed_amount_discount':
          case 'voucher_fixed_amount_discount':
            name = 'Fixed amount discount'
            break
          case 'automatic_free_shipping':
          case 'voucher_free_shipping':
            name = 'Free shipping'
            break
          case 'automatic_discounted_amount':
          case 'voucher_discounted_amount':
            name = 'Discounted amount'
            break
          case 'automatic_buy_get':
          case 'voucher_buy_get':
            name = 'Bundle - But X Get Y'
            break
          case 'automatic_flexi_combo':
            name = 'Flexi combo'
            break
          case 'automatic_bundle_deals':
            name = 'Bundle deals'
            break
          case 'automatic_add_on_deals':
            name = 'Add-on deals'
            break
          default:
            name = 'Unknown promotion type'
            break
        }
        return name
      },
      salesChannelAccountName: function(id){
        let salesChannel = this.salesChannelAccounts.find(r => r.id === parseInt(id))
        return salesChannel ? `${salesChannel.name} (${this.salesChannels.find(r => r.code === salesChannel.sales_channel_type).name})` : ''
      },
    },
    filters: {
      formatPeriodDate: function(date){
        let dateFormat = new Date(date)
        return dateFormat.toLocaleDateString()
      }
    }
  }
</script>
